function bannerSlider(name, autoplay, interval) {
    document.querySelectorAll(name).forEach(carousel => new Splide(carousel, {
        mediaQuery: 'min',
        autoWidth: true,
        gap: 50,
        breakpoints: {
          993: {
                arrows: false,
                drag: false,
                perPage: 3,
                autoWidth: false,
                gap: 0
                //   destroy: true,
              },
        },
        pagination: false
    }).mount());
}